/**
 * Parse a UTC timestamp string into a proper Date object.
 * Handles server timestamps that may be missing the 'Z' suffix.
 */
export function parseUTCDate(dateString: string | Date): Date {
  if (dateString instanceof Date) return dateString;

  // If the string doesn't end with 'Z' or timezone info, assume it's UTC and append 'Z'
  if (!dateString.match(/[+-]\d{2}:\d{2}$/) && !dateString.endsWith('Z')) {
    // Date-only strings (YYYY-MM-DD) need a time component before the 'Z' —
    // appending 'Z' directly produces a non-standard ISO string ("2026-07-26Z")
    // that V8/SpiderMonkey parse leniently but WebKit's stricter Date parser
    // rejects as Invalid Date.
    const suffix = /^\d{4}-\d{2}-\d{2}$/.test(dateString) ? 'T00:00:00Z' : 'Z';
    return new Date(dateString + suffix);
  }

  return new Date(dateString);
}
